import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import { EDTypography, grey, primary, secondary, spacing } from "@trailblazer-game/ed-webkit";
import Stack from "@mui/material/Stack";
import { PRODUCTION } from "../../helpers/environment";
import SettingsIcon from '@mui/icons-material/Settings';
import Box from "@mui/material/Box";
export interface IDebugTools {
    className?: string;
    children?: React.ReactNode | React.ReactNode[]
}

function DebugTools(props: IDebugTools) {
    const { children } = props;
    const [isOpen, setIsOpen] = useState(false);

    if (PRODUCTION) {
        return null;
    }

    const handleToggleClick = (ev: React.MouseEvent<HTMLDivElement>) => {
        setIsOpen(!isOpen);
    }

    return <Stack className={props.className} id={"debug-tools"} direction={"row"} alignItems={"flex-end"}>
        {
            isOpen && <Stack className={"content"}>
                <EDTypography variant={"h6"}>Dev tools </EDTypography>

                {children}
            </Stack>
        }
        <Box title={"Debug tools"} onClick={handleToggleClick}>
            <SettingsIcon sx={{cursor: "pointer"}}/>
        </Box>
    </Stack>
}

const DebugToolsStyled = styled(DebugTools)(() => ({
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: 9000,
    zoom: 0.8,
    "& > .content": {
        padding: spacing(2),
        backgroundColor: secondary("dark"),
    },
    ".input": {
        backgroundColor: grey("1000"),
        padding: spacing(1),
        borderRadius: spacing(1)
    }
}));

// Export
export default DebugToolsStyled;